export class FunctionResourceMapper {
    /**
     * Maps a `FunctionViewModel` object to the format expected by the service.
     * @param actions - Instance of `FunctionViewModel`.
     * @returns Object in the resource format.
     */
    static mapToResource(actions) {
        if (!actions) {
            throw new Error('Invalid actions: actions object is required.');
        }
        if (actions.$invalid) {
            throw new Error(`Invalid actions: ${actions.$validationError?.message || 'Unknown error.'}`);
        }
        return {
            functionContent: actions.functionContent,
            functionName: actions.functionName,
            functionDescription: actions.description,
            functionParameters: actions.inputVariables?.join(', ') || '',
        };
    }
}
